import DOMPurify from 'dompurify';

export const sanitizeHtml = (dirty) => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true } });
};

export default sanitizeHtml;
